<div class="ibox">
    <iboxtools
        *ngIf="otroEmpleador != null"
        [Title]=""
        [isHistory]=true
        [DateInit]="otroEmpleador?.fecha"
        [DateEnd]="otroEmpleador?.fecha"
        [PeriodList]="otroEmpleadorHistoryList"
        [IsEditing]="isEditing"
        (PeriodChange)="OnPeriodChange($event)"
        (NewChange)="OnNewChange($event)"
        (EditChange)="OnEditChange($event)"
        (SaveChange)="OnSaveChange($event)"
        (CutChange)="OnCutChange($event)"
        (DeleteChange)="OnDeleteChange($event)"
        (CancelChange)="OnCancelChange($event)"
        [Permiso]="permisoEdicion"
        [enableCut]=false
    ></iboxtools> 
    <div class="ibox-content" *ngIf="otroEmpleador != null">
      <mat-error *ngIf="otroEmpleadorInvalida" class="otroEmpleadorInvalida">{{MensajeError}}</mat-error>
      <mat-error *ngIf="MensajeRetro && !otroEmpleadorInvalida && isEditing" class="otroEmpleadorInvalida">{{MensajeRetro}}</mat-error>
      <form [formGroup]="form">
        <div class="row" hidden="true">
          <input formControlName="id" name="id" type="text" class="form-control" />
          <input formControlName="personal" name="personal" type="text" class="form-control" />
        </div>
        <div class="row">
            <div class="col-md-6">
              <label class="col-form-label font-bold" for="fecha">Fecha</label>
              <div class="fechaC">
                <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fecha" dateFormat="dd/mm/yy" inputId="fecha" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
                <div *ngIf="registerFormControl.fecha.errors?.required && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">La Fecha es Requerida</div>
                <mat-error *ngIf="desdeAnterior && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">
                  No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
                </mat-error>
                <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">
                  No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
                </mat-error>
              </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class=" col-form-label font-bold">Empleador</label>
                    <input formControlName="empleador" maxlength="100" name ="selectedEmpleador" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.empleador.errors && (registerFormControl.empleador?.dirty || registerFormControl.empleador?.touched || submitted)}"/>
                    <mat-error  class="text-danger"*ngIf="registerFormControl.empleador.errors?.required && (registerFormControl.empleador?.dirty || registerFormControl.empleador?.touched || submitted)">
                        El Empleador es Requerido
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label class="col-form-label font-bold">Clase Documento</label>
                <div>
                <comboTools [list]=clasesDocList
                            selected='claseDocumento'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion"
                            ph='Clase de Documento'></comboTools>
                <div *ngIf="registerFormControl.claseDocumento.invalid && (registerFormControl.claseDocumento?.dirty || registerFormControl.claseDocumento?.touched || submitted)" class="text-danger">
                    La Clase Documento es Requerida
                </div>
                </div>
            </div>
            <div class="col-md-6">
                <label class=" col-form-label font-bold">Nro. Documento</label>
                <input formControlName="docNro" name ="selectedDocNro" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.docNro.errors && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)}"/>
                <mat-error  class="text-danger"*ngIf="registerFormControl.docNro.errors?.required && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)">
                    El Nro. Documento es Requerido
                </mat-error>
            </div>
        </div>
        <br>
      </form>
      
      <div *ngIf="!onlyNew">
        <div *ngIf="!disabledEditing" class="row wrapper white-bg page-heading">
          <div class="col-lg-12">
            <h2>
              <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar Concepto" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='addConcepto()'></button>
            </h2>
          </div>
        </div>
        <div class="table table-striped">
          <p-table #dt [value]="conceptosList" [rows]="10" [paginator]="true" [rowHover]="true" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Importe</th>
                <th>Moneda</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-concepto let-rowIndex="rowIndex">
              <tr>
                <td>{{concepto.codigoNominaNavigation.codigo}}</td>
                <td>{{concepto.codigoNominaNavigation.descripcion}}</td>
                <td class="text-right">{{concepto.cantidad}}</td>
                <td class="importe">{{concepto.importe | numeroDecimal}}</td>
                <td>{{concepto.monedaNavigation.descripcion}}</td>
                <td>
                  <button *ngIf="isEditing" pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="editConcepto(concepto, rowIndex)"></button>
                  <button *ngIf="isEditing" pButton pRipple pTooltip="Eliminar" tooltipPosition="bottom" icon="pi pi-trash" class="btn btn-xs  btn-danger" (click)="deleteConcepto(concepto, rowIndex)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td class="pieTotales">Total:</td>
                <td></td>
                <td></td>
                <td class="importe pieTotales">{{totalImporte | numeroDecimal}}</td>
                <td class="pieTotales p-text-left">{{monedaConcepto}}</td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
      
    </div>
</div>

<div class="ibox-content m-b-sm border-bottom" *ngIf="otroEmpleador == null && cargaCompleta">
  <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
  <div class="p-xs">
    <div class="float-left m-r-md">
      <i class="fa fa-globe text-navy mid-icon"></i>
    </div>
    <h2>Empleado sin Otro Empleador</h2>
    <span>El empleado no tiene Otro Empleador.</span>
  </div>
</div>
